import { Link, useNavigate, useParams } from 'react-router-dom';
import galleryimg from '../assets/images/gallery.png';
import searchicon from '../assets/images/search.png';
import backicon from '../assets/images/back.png';
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"
import { publicPost } from '../slices/posts';
import { useTranslation } from 'react-i18next';

const PostView = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const { post } = useSelector((state) => state.posts);
    const { user } = useSelector((state) => state.auth);

    let currentLang = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : 'en';

    useEffect(() => {
        if(user && user.approve == "N") {
            navigate('/profile');
        }

        let param = { id, currentLang };
        dispatch(publicPost(param))
    }, []);

    return (
        <div className="container">
            <section className="mt-5 pt-5 gallery memberDetails">
                <div className="row">
                    <div className='col-md-12'>
                        <Link to='/posts' className='back-link'>
                            <img src={backicon} style={{ width: "auto" }} />
                        </Link>
                    </div>
                    <div className='col-md-12 mt-2-5'>
                        <div className='section-title'>
                            <h1><span className='font-color-1'>{t('post')}</span> <span className='font-color-2'>{t('details')}</span></h1>
                            <p>{post?.created_at}</p>
                        </div>
                    </div>

                    <div className='col-md-12 mt-2-5'>
                        <div className='card post-card home-card'>
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-md-6 mb-2'>
                                        <img src={post?.image_path} />
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='ps-3'>
                                            <h3 className='post-title'>{post?.title}</h3>
                                            <p className='post-content mt-1-5'>
                                                {post?.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
export default PostView;